import React from "react";
import PropTypes from "prop-types";
import {
    Form,
    FormGroup,
    Label,
    Input,
    Col,
    Button,
} from "reactstrap";

/**
 * Upload Roster CSV Form Component
 */
const UploadRosterCSVForm = ({
    shop,
    isShow,
    onInputChange,
    onDiscountInputChange,
    onSubmit,
    onShowData,
    onShowAllCampaigns,
}) => {
    return (
        <Form onSubmit={onSubmit}>
            <FormGroup className="row mb-4">
                <Label
                    htmlFor="horizontal-shop-Input"
                    className="col-sm-2 col-form-label text-md-right"
                    style={{ textAlign: "center" }}
                >
                    Store Domain
                </Label>
                <Col sm={4}>
                    <Input
                        value={shop}
                        type="text"
                        name="shop"
                        className="form-control"
                        id="horizontal-shop-Input"
                        readOnly
                    />
                </Col>
            </FormGroup>
            <FormGroup className="row mb-4">
                <Label
                    htmlFor="horizontal-placement-Input"
                    className="col-sm-2 col-form-label text-md-right"
                    style={{ textAlign: "center" }}
                >
                    Influencer CSV File <span style={{ color: 'red' }}>*</span>
                </Label>
                <Col sm={4}>
                    <input
                        type="file"
                        id="csvFileInput"
                        accept=".csv"
                        onChange={onInputChange}
                    />
                </Col>
            </FormGroup>
            <FormGroup className="row mb-4">
                <Label
                    htmlFor="horizontal-placement-Input"
                    className="col-sm-2 col-form-label text-md-right"
                    style={{ textAlign: "center" }}
                >
                    Discount CSV File <span style={{ color: 'red' }}>*</span>
                </Label>
                <Col sm={4}>
                    <input
                        type="file"
                        id="discountedFileInput"
                        accept=".csv"
                        onChange={onDiscountInputChange}
                    />
                </Col>
            </FormGroup>
            <FormGroup className="row justify-content-end">
                <Col sm={8}>
                    <div>
                        {isShow && (
                            <Button
                                type="submit"
                                color="primary"
                                className="w-md"
                            >
                                Add Campaign
                            </Button>
                        )}
                        {!isShow && (
                            <button
                                type="button"
                                className="btn btn-danger waves-effect waves-light"
                                onClick={onShowData}
                            >
                                Show Data
                            </button>
                        )}
                    </div>
                </Col>
                <Col sm={2} style={{ textAlign: "right" }}>
                    <Button
                        type="button"
                        color="secondary"
                        className="w-md btn btn-primary float-right"
                        onClick={onShowAllCampaigns}
                    >
                        All Campaigns
                    </Button>
                </Col>
            </FormGroup>
        </Form>
    );
};

UploadRosterCSVForm.propTypes = {
    shop: PropTypes.string.isRequired,
    isShow: PropTypes.bool.isRequired,
    onInputChange: PropTypes.func.isRequired,
    onDiscountInputChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onShowData: PropTypes.func.isRequired,
    onShowAllCampaigns: PropTypes.func.isRequired,
};

export default UploadRosterCSVForm;

